import { LatitudeLongitude, noop } from '@aloft/toolkit-shared';

import { useEffect, useState } from 'react';

import { useLatLngFromAddress } from './useLatLngFromAddress.ts';
import { useMakeStreetViewStaticURL } from './useMakeStreetViewStaticURL.ts';

export const useStreetViewStaticUrl = (
  shouldGetUrl: boolean,
  address?: string,
  passedPosition?: LatitudeLongitude,
): string | undefined => {
  const [url, setUrl] = useState<string | undefined>(undefined);
  const { latLng, status } = useLatLngFromAddress(address, shouldGetUrl);

  const makeStreetViewStaticURL = useMakeStreetViewStaticURL();

  useEffect(() => {
    const fetchUrl = async () => {
      if (!shouldGetUrl || !makeStreetViewStaticURL) return;

      if (status === 'pending') {
        setUrl(undefined);
        return;
      }

      // Got position, but wasn't a thing
      if (!latLng) {
        // No passed position, no geocoded position
        if (!passedPosition) {
          setUrl(undefined);
          return;
        }

        // No geocode version, yes passed version
        setUrl(await makeStreetViewStaticURL(passedPosition));
        return;
      }

      setUrl(await makeStreetViewStaticURL(latLng));
    };

    fetchUrl().then(noop).catch(console.error);
  }, [makeStreetViewStaticURL, latLng, passedPosition, shouldGetUrl, status]);

  return url;
};
